/**
 * Pings on an interval and reports the socket dead when a pong does not come back in time. A
 * WebSocket the network dropped stays "open" on both ends: this is the only way to notice it.
 */
export class KeepAlive {
    private intervalTimer: ReturnType<typeof setInterval> | null = null;
    private timeoutTimer: ReturnType<typeof setTimeout> | null = null;

    private readonly ping: () => void;
    private readonly onDead: () => void;
    private readonly intervalMs: number;
    private readonly timeoutMs: number;

    constructor(ping: () => void, onDead: () => void, intervalMs: number, timeoutMs: number) {
        this.ping = ping;
        this.onDead = onDead;
        this.intervalMs = intervalMs;
        this.timeoutMs = timeoutMs;
    }

    start(): void {
        this.stop();
        this.intervalTimer = setInterval(() => this.probe(), this.intervalMs);
    }

    pong(): void {
        if (this.timeoutTimer) {
            clearTimeout(this.timeoutTimer);
            this.timeoutTimer = null;
        }
    }

    stop(): void {
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
        }

        this.pong();
        this.intervalTimer = null;
    }

    /** Pings now, e.g. when the page comes back from the background with a socket that may be dead. */
    probe(): void {
        if (!this.intervalTimer || this.timeoutTimer) {
            return;
        }

        this.ping();
        this.timeoutTimer = setTimeout(() => {
            this.stop();
            this.onDead();
        }, this.timeoutMs);
    }
}
